module.exports = __webpack_public_path__ + "img/battery_dead.aa7c4855.svg";